var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthDiaryNewTemperatureEntry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffaed9;}.cls-2{fill:#fce3f1;}.cls-3{fill:#ff4a4a;}.cls-4{fill:#fff;}.cls-5{fill:#febe10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_127",
    "data-name": "Layer 127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.33,500a102,102,0,0,1-59.84-184.71l6.2-4.49v-241a53,53,0,1,1,106.09,0V310.07l6.35,4.48a102.61,102.61,0,0,1,20.2,18.76H303.22c-.62,0-1.24,0-1.85,0-50.87,1-92.23,43.15-92.23,94.07a94,94,0,0,0,34.1,72.43Q240.3,500,237.33,500Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.74,31.7a38.09,38.09,0,0,1,38,38.05V317.84l4.47,3.16c-48.54,11-85.11,54.85-85.11,106.4a108.94,108.94,0,0,0,13.41,52.35,87,87,0,0,1-21.27-152.31l12.41-9V69.75a38.09,38.09,0,0,1,38.05-38m0-30a68.13,68.13,0,0,0-68.05,68.05V303.14a117,117,0,0,0,117,201.39,79.09,79.09,0,0,1,16.1-156.2c.48,0,1,0,1.44,0h40.17a116.86,116.86,0,0,0-38.61-46V69.75a68.12,68.12,0,0,0-68-68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 206.15,
    y: 43.71,
    width: 62.23,
    height: 258.61,
    rx: 31.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.14,427.4a78.76,78.76,0,0,0,19.26,51.68c-2,.15-4,.23-6.07.23A81.37,81.37,0,0,1,205.5,323.06V156.15a31.24,31.24,0,0,1,31.24-31.25A31.25,31.25,0,0,1,268,156.15V322.58a81.59,81.59,0,0,1,33.8,25.75A79.16,79.16,0,0,0,224.14,427.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 199.91,
    cy: 369.81,
    rx: 23.46,
    ry: 13.93,
    transform: "translate(-208.51 270.19) rotate(-47.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599.86,427.4a49.24,49.24,0,0,1-49.09,49.1H471.66v74.72a49.1,49.1,0,0,1-98.19,0V476.5H303.22a48.69,48.69,0,0,1-26.11-7.57,49.07,49.07,0,0,1,26.11-90.62h70.25V303.67c0-.56,0-1.12,0-1.68a49.09,49.09,0,0,1,98.15,1.68v74.64h79.11A49.23,49.23,0,0,1,599.86,427.4Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDiaryNewTemperatureEntry);
export default __webpack_public_path__ + "static/media/health_diary_new_temperature_entry.ca73a049945069b398d50bc5f14b3224.svg";
export { ForwardRef as ReactComponent };